export default __webpack_public_path__ + "static/media/Xfooter.e6f73a3d.svg";